//libraries
import React from 'react'

// components
import Section from '/react4xp/components/Section'
import Button from '/react4xp/components/Button'

// utils
import { isNonWhitespaceString } from '/lib/reactutils/utils.js'

// prop types
export interface Error404WrapperProps {
    heading?: string
    text?: string
    buttonLink?: string
    buttonText?: string
}

export default function Error404Wrapper({
    heading,
    text,
    buttonLink,
    buttonText
}: Error404WrapperProps) {
    return (
        <main id='main' className='page-error-404'>

            <Section
                className='page-error-404__main'
                marginTop='big'
                marginBottom='big'
            >
                <div className='container'>
                    <div className='row'>
                        <div className='col-sm-10 offset-sm-1 col-lg-6 offset-lg-3'>
                            
                            {isNonWhitespaceString(heading) && (
                                <h1 className='h1-hero-small'>
                                    {heading}
                                </h1>
                            )}

                            {isNonWhitespaceString(text) && (
                                <p className='text-big'>
                                    {text}
                                </p>
                            )}

                            {isNonWhitespaceString(buttonLink) && isNonWhitespaceString(buttonText) && (
                                <Button
                                    href={buttonLink}
                                    noUnderline
                                >
                                    {buttonText}
                                </Button>
                            )}

                        </div>
                    </div>
                </div>
            </Section>

        </main>
    )
}